import { render } from "./AddSkuModal.vue?vue&type=template&id=2b7aa61a&scoped=true&ts=true"
import script from "./AddSkuModal.vue?vue&type=script&lang=ts"
export * from "./AddSkuModal.vue?vue&type=script&lang=ts"

import "./AddSkuModal.vue?vue&type=style&index=0&id=2b7aa61a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7aa61a"]])

export default __exports__